import { render } from "./Loading.vue?vue&type=template&id=0fa042c2"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=0fa042c2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/r/Desktop/ev-switch-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__